import { getPolygons } from 'modules/api/polygon';
import { loadPolygons } from 'store/carto/reducer';
import { cancelFunctions } from 'utils/cancelFunctions';
import { LoadCampaignPolygonsArgs } from './campaignPostSaveRefresh.types';
import { transformPolygonsResponse } from './transformPolygonsResponse';

export const loadCampaignPolygons = async ({
  dispatch,
  settings,
  marketId,
  polygonCampaignId,
}: LoadCampaignPolygonsArgs): Promise<void> => {
  if (!settings.shouldLoadPolygons) return;

  const polygonsResult = await getPolygons(marketId, polygonCampaignId, cancelFunctions);
  dispatch(loadPolygons(transformPolygonsResponse(polygonsResult)));
};
